export default __webpack_public_path__ + "static/media/medium.e752ddfe.svg";